module.exports = __webpack_public_path__ + "img/lxwm—icon.80846990.png";